import { pacific, pebbleBeach, t1000 } from './colors';

export default {
    blockquote: `5px solid ${pacific}`,
    abbr: `1px dotted ${pebbleBeach}`,
    content: `2px solid ${t1000}`,

    borderRadiuses: {
        base: 3,
        small: 3,
        medium: 5,
        large: 8,
    },
};
